import { Card } from "antd";
import { RequiresBroker } from "../../brokers/components/RequiresBroker";
import { SelectBrokerDropdown } from "../../brokers/components/SelectBrokerDropdown";
import SocialTrade from "../../signals/components/SocialTrade";
import { PositionsAndOrdersCard } from "../components/PositionsAndOrdersCard";
import { QuickTrade } from "../../trade/components/QuickTrade";
import AccountDetails from "../../brokers/components/AccountDetails";
import { AccountBalanceCard } from "../components/AccountBalanceCard";
import styles from './dashboard.module.scss';
import { AnalystTradeChart } from "../components/AnalystTradeChart";
import { WatchlistItemContextProvider } from "../../watchlist/context/watchlist-item-context";
import { Watchlist } from "../../watchlist/components/Watchlist";
import { CollapsibleSection } from "../components/CollapsibleSection";
import { ShareTradeCard } from "../components/ShareTradeCard";
import { useAuthUser } from "../../auth/hooks/useAuthUser";
import { AffiliateAlert } from "../../affiliate/AffiliateAlert";
import { ResetWebullPaperAccountButton } from "../../brokers/components/ResetWebullPaperAccountButton";
import { TransacionsCard } from "../components/TransactionsCard";
import { SignalParserCard } from "../components/SignalParserCard";
import { WatchlistContextProvider } from "../../watchlist/context/watchlist-context";
import { AskNotificationPermission } from "../../notifications/components/ask-notification-permission";
import { ChatCollapsibleSection } from "../../chat/ui/chat-collapsible-section";

export const Dashboard = () => {
  const { user } = useAuthUser();
  const showWatchlist = !!user;

  return (
    <RequiresBroker>
      <WatchlistContextProvider>
        <WatchlistItemContextProvider>
          <div className={`${styles.container}`}>
      
            <div className={`${styles.row}`}>

              {
                showWatchlist && <div className={`${styles.watchlistRow}`}>
                  <Card bodyStyle={{ padding: 0 }} style={{ padding: 0 }}>
                    <Watchlist layout="horizontal"/>
                  </Card>
                </div>
              }

              <div className={`${styles.contentColumn}`}>
                <AffiliateAlert />
                <div className={`${styles.balanceAndBrokerRow}`}>
                  <AccountBalanceCard />
                  <Card 
                    style={{ display: 'flex', alignItems: 'center' }}
                    bodyStyle={{ paddingLeft: 0, paddingRight: 0, gap: 4 }}
                  >
                    <SelectBrokerDropdown />
                    <ResetWebullPaperAccountButton style={{ marginLeft: 16 }} />
                  </Card>
                </div>            
                
                <AskNotificationPermission />
                
                <AnalystTradeChart />
                <CollapsibleSection title="Signal Feed">
                {/* <CollapsibleSection defaultOpen={false} title="Signal Feed"> */}
                  <SocialTrade />
                </CollapsibleSection>
                <CollapsibleSection title="Positions & Orders">
                  <PositionsAndOrdersCard />
                </CollapsibleSection>
                <CollapsibleSection title="Transactions">
                  <TransacionsCard />
                </CollapsibleSection>
              </div>

              <div className={`${styles.sidebarColumn}`}>
                <ShareTradeCard />
                <QuickTrade
                  syncWithWatchlist={true}
                  title="Smart Trader"
                />
                <CollapsibleSection title="AI TradeSync">
                  <SignalParserCard />
                </CollapsibleSection>
                <ChatCollapsibleSection />
                <CollapsibleSection title="Account Details">
                  <AccountDetails />
                </CollapsibleSection>
              </div>

              {
                showWatchlist && <div className={`${styles.watchlistColumn}`}>
                  <Card bodyStyle={{ padding: 0 }} style={{ padding: 0 }}>
                    <Watchlist layout="vertical"/>
                  </Card>
                </div>
              }
              
            </div>
          </div>
        </WatchlistItemContextProvider>
      </WatchlistContextProvider>
    </RequiresBroker>
  );
};